namespace TabAurous.Administration {
    export interface SequenceForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Processes: SequenceDetailsEditor;
    }

    export class SequenceForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Sequence';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SequenceForm.init)  {
                SequenceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = SequenceDetailsEditor;

                Q.initFormType(SequenceForm, [
                    'Code', w0,
                    'Name', w0,
                    'Processes', w1
                ]);
            }
        }
    }
}
